"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _clsx = _interopRequireDefault(require("clsx"));

var _makeStyles = _interopRequireDefault(require("@material-ui/styles/makeStyles"));

var _reactSvgIcon = require("@micado-digital/react-svg-icon");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var useStyles = (0, _makeStyles.default)(function (theme) {
  return {
    root: {
      cursor: "pointer",
      display: "inline-flex",
      userSelect: "none"
    }
  };
});

var Close = function Close(_ref) {
  var close = _ref.close,
      icon = _ref.icon;
  var css = useStyles();
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)("menu-01-mobile-close", css.root),
    onClick: close
  }, /*#__PURE__*/_react.default.createElement(_reactSvgIcon.ReactSVGIcon, {
    src: icon
  }));
};

Close.propTypes = {
  close: _propTypes.default.func.isRequired,
  icon: _propTypes.default.string.isRequired
};
var _default = Close;
exports.default = _default;